var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`grade-selector-content pa-5 d-flex flex-column text-center cursor-pointer  ${
        _vm.active ? 'grade-active' : ''
    }`,on:{"click":_vm.setActive}},[_c('span',{staticClass:"text-title"},[_vm._v(_vm._s(_vm.grade.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }